<template>
    <!-- theme one -->
        <div v-if="themeStore.themeIndex === 1">
         <ReportViewOne :data-set="dataSet" @switchClick="switchClick"/>
       </div>
       <!-- theme two -->
       <div v-if="themeStore.themeIndex === 2">
         <ReportViewTwo :data-set="dataSet" @switchClick="switchClick"/>
       </div>
        <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
 <LoadingScreen ref="loadingRef" /> 


</template>
<script setup lang="ts">
import { getDescendants } from '@/api/bauDoTesouro';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import ReportViewOne from '@/themes/themeOne/report/reportView.vue';
import ReportViewTwo from '@/themes/themeTwo/report/reportView.vue';
import { useTreasureActivityStore } from '@/stores/treasure';
import { computed, onMounted, ref } from 'vue';
import { DataList, ReportData } from './supportScript';
import { useThemeStore } from '@/stores/theme';

const isSuccess = ref(false)
const statusRef = ref()
const loadingRef = ref()
const toastContent = ref('')
const themeStore = useThemeStore()

const checked = ref(false)
const descendantsList = ref<DataList[]>([])
const activityStore = useTreasureActivityStore()
const rechargeRequire = computed(() => activityStore.rechargeRequire);
const turnoverRequire = computed(() => activityStore.turnoverRequire);
const ipLimit = computed(() => activityStore.ipLimit);

const switchClick = () => {
    checked.value = !checked.value
    getDescendantsList()
}
const dataSet = computed<ReportData>(() => ({
    rechargeRequire: rechargeRequire.value,
    turnoverRequire: turnoverRequire.value,
    ipLimit: ipLimit.value,
    checked: checked.value,
    descendantsList: descendantsList.value,
}))
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getDescendantsList = () => {
    loadingRef.value.open()
    let data = {
        is_effective: checked.value ? 1 : 0,
        page_num: 1,
        page_size: 20
    }
    getDescendants(data).then(res => {
        loadingRef.value.close()
        let resData = res.data.rows[0]
        descendantsList.value = resData.descendants

    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}

onMounted(() => {
    getDescendantsList()
})
</script>
<style scoped>
.report_container {
    min-height: 100vh;
    padding: 70px 15px;
}

.report_title {
    color: #fff;
    font-size: 15px;
    padding: 5px;
}

.row_feild {
    background: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.85);
    padding: 15px 20px;
    margin: 5px 0;
}

.alignment {
    display: flex;
    align-items: center;
}

.row_text {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.65);
    justify-content: right;
}

.row_text span {
    font-size: 15px;
    font-weight: 700;
    color: #FFAF00;
}

.row_text img {
    width: 35px;
    margin: 0 5px;
}

.sub_row {
    border-radius: 10px;
    background-image: linear-gradient(98deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.04) 100%);
    padding: 15px;
    margin-top: 35px;
}

.icon_text {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    font-size: 15px;
    color: #fff;
}

.icon_text img {
    width: 30px;
}

.line {
    width: 1px;
    background: rgba(255, 255, 255, 0.15);
    height: 10px;
}

.tabel_head {
    padding: 20px 10px;
    background: rgba(255, 255, 255, 0.25);
    box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.15);
    border-radius: 10px 10px 0 0;
    color: rgba(255, 255, 255, 0.85);
    font-weight: 700;
    font-size: 14px;
}

.tabel_alignment {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.tabel_row {
    color: rgba(255, 255, 255, 0.85);
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding: 10px;
    font-size: 13px;
}

.tabel_row .van-col {
    padding: 10px 0;
    color: rgba(255, 255, 255, 0.65);
}

.table_container {
    margin-top: 5px;
}
.noMoreData{
    display: flex;
    justify-content: center;
    padding-top: 10px;
    color: #fff;
}
</style>